import { useOverrides } from '../hooks/use-overrides'
import { Tab, TabOverrides, TabProps } from 'baseui/tabs-motion'
import { margin, padding } from 'polished'
import { colors } from '@styles/colors'
import { typography } from '@styles/typography'

export const tabOverrides: TabOverrides = {
  Tab: {
    style: ({ $isActive }) => ({
      fontWeight: 700,
      color: $isActive ? colors.gray700 : colors.gray400,
      ...padding('8px', '16px'),
      ...margin('0px'),
      ...typography.LabelL,
      whiteSpace: 'pre',
      ':hover': {
        background: colors.gray50,
      },
    }),
  },
  TabPanel: {
    style: {
      ...padding('16px', '0px'),
      color: colors.gray700,
    },
  },
}

export const BaseTab = ({ children, overrides, ...props }: TabProps) => {
  return (
    <Tab
      overrides={useOverrides<TabOverrides>(tabOverrides, overrides)}
      {...props}
    >
      {children}
    </Tab>
  )
}
